module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0080.jpg?v=80469653";